import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const tvRoutes: RouteObject[] = [
  {
    path: '/tv/streams',
    element: lazyElement(() => import('./Main')),
    handle: { crumb: () => ({ label: 'TV Streams', to: '/tv/streams' }) },
  },
];

export default tvRoutes;

